import classNames from 'classnames'
import { NumberedMilestoneGroup } from './progression-milestone'
import { ProgressionNavItem } from './progression-nav-item'

export function ProgressionNavGroup({
  group,
  signalMilestone,
  completedMilestones,
  onMilestoneClick
}: {
  group: NumberedMilestoneGroup
  signalMilestone: (id: string) => void
  completedMilestones: Set<string>
  onMilestoneClick: (id: string) => void
}) {
  return (
    <li
      className={classNames(
        'poe-milestone-group',
        group.visible === false && 'poe-milestone-group-hidden'
      )}>
      <span>{group.title}</span>
      <ul>
        {group.items.map((milestone) => (
          <ProgressionNavItem
            key={milestone.id}
            milestone={milestone}
            signalMilestone={signalMilestone}
            completedMilestones={completedMilestones}
            onMilestoneClick={onMilestoneClick}
          />
        ))}
      </ul>
    </li>
  )
}
